const style = [
  {
    selector: "node",
    style: {
      "shape": "rectangle",
      "font-family": "Libre Franklin,sans-serif",
      "font-weight": "bold",
    },
  },
  {
    selector: "node[type = 'root']",
    style: {
      "label": "data(name)",
      "text-wrap": "wrap",
      "color": "#333333",
      "shape": "rectangle",
      "background-color": "#e0e1dd",
      "border-width": "2",
      "border-color": "#707070",
      "text-border-width": "10",
      "text-border-opacity": "1",
      "text-border-color": "#e0e1dd",
      "width": "label",
      "font-size": "25px",
      "text-halign": "center",
      "text-valign": "center",
      "padding": "15",
    },
  },
  {
    selector: "node[type = 'node']",
    style: {
      "label": "data(name)",
      "color": "#333333",
      "shape": "rectangle",
      "background-color": "#CDD7D9",
      "border-width": "2",
      "border-color": "#707070",
      "font-size": "18px",
      "width": "280px",
      "height": "label",
      "text-border-width": 10,
      "text-border-opacity": 1,
      "text-border-color": "#CDD7D9",
      "text-wrap": "wrap",
      "text-max-width": "300px",
      "text-halign": "center",
      "text-valign": "center",
      "padding-left": "15",
    },
  },
  {
    selector: "node[type = 'leaf']",
    style: {
      "font-size": "12px",
      "background-color": "#ffffff",
      "width": "240px",
      "text-wrap": "wrap",
      "text-max-width": "220px",
      "text-halign": "center",
      "text-valign": "center",
      "color": "#5A5B64",
      "text-border-width": 10,
      "text-border-opacity": 1,
      "text-border-color": "#ffffff",
      "shape": "rectangle",
      "border-width": "2",
      "border-color": "lightgrey",
      "height": "label",
      "padding-left": "10",
      "label": "data(message)",
    },
  },
  {
    selector: "node[type = 'group']",
    style: {
      "label": "data(name)",
      "font-size": "12px",
      "background-opacity": 0.5,
      "width": "100",
      "border-width": 3,
      "border-color": "grey",
    },
  },
  {
    selector: "node:parent",
    css: {
      "background-opacity": 0,
      "border-width": 1,
    },
  },

  {
    selector: "edge[type = 'inner']",
    css: {
      "color": "black",
      "curve-style": "straight",
      "line-color": "black",
      "width": "0",
    },
  },
  {
    selector: "edge[type = 'outer']",
    css: {
      "line-color": "grey",
      "width": "1",
      "target-arrow-fill": "hollow",
      "curve-style": "taxi",
    },
  },
]

export default style
